module.exports = __webpack_public_path__ + "static/media/gray-right-arrow.ea33835c.svg";